import { HTTP, rootApi } from '../index';
import { GetStripeProductsResponse } from './types';

export const stripeProductApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({

    getStripeProducts: builder.query<GetStripeProductsResponse, {country_code: string}>({
      query: ({country_code}) => {
        return {
          url: `/stripe_products?country_code=${country_code}`,
          method: HTTP.GET,
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetStripeProductsQuery,
} = stripeProductApi;
